export const experienceData = [
     {
        id: 1,
        company: 'Goosehead Insurance, Westlake, TX',
        jobtitle: 'Senior Software Engineer',
        startYear: 'Oct 2025',
        endYear: 'Present'
    },
    {
        id: 2,
        company: 'Caspex Corp (Walmart), Remote',
        jobtitle: 'Full Stack UI React Developer (Contract)',
        startYear: 'June 2024',
        endYear: 'Sep 2025'
    },
    {
        id: 3,
        company: 'TGS Technology LLC, Columbus, OH',
        jobtitle: 'UI React Developer (Contract)',
        startYear: 'April 2024',
        endYear: 'June 2024'
    },
    {
        id: 4,
        company: 'one.com, Dubai',
        jobtitle: 'Team Lead',
        startYear: 'March 2019',
        endYear: 'Feb 2024'
    },
    {
        id: 5,
        company: 'Pramati Technologies, Hyderabad',
        jobtitle: 'Senior Development Engineer',
        startYear: 'March 2015',
        endYear: 'Feb 2019'
    },
    {
        id: 6,
        company: 'MAQ Software, Hyderabad',
        jobtitle: 'Software Engineer',
        startYear: 'May 2013',
        endYear: 'Feb 2015'
    },
]